import React from 'react';
import { useParams } from 'react-router-dom';
import InvoiceCreate from './InvoiceCreate';

const InvoiceCreateWrapper: React.FC = () => {
  const { organisationId } = useParams<{ organisationId: string }>();

  if (!organisationId) {
    return <div>Organisation ID is required</div>;
  }

  return <InvoiceCreate organisationId={organisationId} />;
};

export default InvoiceCreateWrapper;
